import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DynamicTabsService, GeneralService, RouterDataService, SessionStorageService} from 'ac-infra';

@Injectable({
    providedIn: 'root'
})
export class NavigatorService {

    private navbarController: any;

    constructor(private sessionStorageService: SessionStorageService,
                private router: Router,
                private generalService: GeneralService,
                private routerDataService: RouterDataService,
                private dynamicTabsService: DynamicTabsService) {
    }

    public goTo = (stateName, params?) => {
        this.router.navigate([stateName], params);
    }

    public goToWithFilter = (stateName, filter) => {
        // this.filterState.stateStartEventHandler(stateName, filter);
        this.router.navigate([stateName]);
    }

    public goToDynamicTab = (pathsFragments: any | any[], title?, icon?) => {
        if (!Array.isArray(pathsFragments)) {
            pathsFragments = [pathsFragments];
        }
        this.dynamicTabsService.addTab(pathsFragments[0], title, icon);
        this.router.navigate([pathsFragments.join('/')]);
    }

    public gotoLastSavedState = () => {
        this.router.navigateByUrl('dashboard');
        // let lastState: any = this.getLastSavedState();
    }

    public registerNavigationBar = (navbarCtrl) => {
        this.navbarController = navbarCtrl;
    }
}
